
<template>
	<v-dialog
			:value="isSendPpwFile"
			content-class="dialogWrapper"
			persistent
			width="340"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>Send paperwork to email</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="fieldGroup">
					<div class="groupFieldTitle">
						<span>Email list</span>
						<button type="button" @click="onAddItem">
							<svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
						</button>
					</div>
					<template v-for="({ mail }, idx) in mails">
						<div class="groupField_wrap" :key="idx">
							<field
									margin="0"
									:classError="getError(idx)"
									label="Email"
									placeholder="Enter email"
									@updateInput="onInput($event, mail)"
									:setInputValue="mail"
									:idx="idx"
									is-required
									is-trim
							></field>
							<button type="button" class="deleteItem" @click="onDelete(idx)">
								<svg-sprite width="20" height="20" icon-id="deleteItem"></svg-sprite>
							</button>
						</div>
					</template>
				</div>
			</div>
			<div class="dialogFooter">
				<div class="buttonGroups">
					<custom-btn
							margin="0"
							text="CANCEL"
							custom-class="cancel"
							@updateEvent="onClose"
					></custom-btn>
					<custom-btn
							margin="0"
							text="Send"
							custom-class="apply"
							@updateEvent="onSendPpwFile"
					></custom-btn>
				</div>
			</div>
		</div>
	</v-dialog>
</template>

<script>

import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";

export default {
	name: "SendPpwFile",
	mixins: [ validationMixin ],
	props: {
		items: Array,
	},

	validations() {
		return {
			mails: {
				$each: {
					mail: { required, email },
				}
			}
		};
	},
	data: () => ({
		isSendPpwFile: true,
		mails: [
			{ mail: null },
		],
	}),
	methods: {
		getError(idx) {
			return this.$v.mails?.$each?.$iter[idx]?.mail?.$error;
		},
		onInput({ value, idx }) {
			this.mails[idx]['mail'] = value;
		},
		onAddItem() {
			const item = { mail: null };
			this.mails.push(item);
		},
		onSendPpwFile() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const data = this.mails;
				this.$emit('updateSendPpwFile', { data });
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "Saving error" });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},
		onDelete(idx) {
			// Проверка, является ли this.mails массивом
			if (Array.isArray(this.mails)) {
				// Проверка, является ли индекс idx допустимым индексом массива
				if (idx >= 0 && idx < this.mails.length) {
					// Использование splice для удаления элемента с индексом idx
					this.mails.splice(idx, 1);
				} else {
					console.error('Invalid index:', idx);
				}
			} else {
				console.error('this.mails is not an array');
			}		
		},
	}
};
</script>

<style scoped lang="scss">
@import "../../dialog";
@import "SendPpwFile";
</style>
